import React from 'react';
import { Navigate } from 'react-router-dom';

const Page = React.lazy(() => import('./ChildContractReportPage'));

const ChildContractReportConfig = {
	settings: { layout: { config: {} } },
	routes: [
		{
			path: '/billing/reports/child-contracts',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Page />
				</React.Suspense>
			),
		},
		// THE RETIRED CHILDREN WITHOUT CONTRACT ADDRESS. That population is now
		// the top section of this screen and the standalone page is gone, but
		// the application sends an unknown path to `/404` — so a bookmark or a
		// link to the old address answered "not found" for a report that had in
		// fact been absorbed rather than removed. `replace` so the retired
		// address does not sit in the history behind the reader and send them
		// straight back to it on one press of the back button.
		{
			path: '/billing/reports/children-without-contract',
			element: <Navigate replace to="/billing/reports/child-contracts" />,
		},
	],
	auth: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default ChildContractReportConfig;
